// extracted by mini-css-extract-plugin
module.exports = {"root":"usp_root__oAbqQ","rootLink":"usp_rootLink__thi76"};